// extracted by mini-css-extract-plugin
export default {"header":"Home_header__jgN9+","grid":"Home_grid__w2Biy","card":"Home_card__+O6lb"};